export default __webpack_public_path__ + "static/media/kravayura.42cfedd8.png";